import React from "react";
import "./successCancellationModal.scss";
import tick from "../../assets/tick.svg";
import { withStyles } from "@material-ui/styles";
import { Dialog } from "@material-ui/core";
import close_icon from "../../assets/crossIcon.svg";

const styles = {
  dialogPaper: {
    maxWidth: "692px",
    background: "#FFFFFF 0% 0% no-repeat padding-box",
    boxShadow: "0px 3px 6px #00000029",
    borderRadius: "10px",
    margin: window.innerWidth > 768 ? "" : "19px",
  },
};

const SuccessCancellationModal = (props) => {
  const { classes, show, reason, handleClose } = props;
  return (
    <>
      {show && (
        <Dialog
          open={show}
          classes={{
            paper: classes.dialogPaper,
          }}
        >
          <div className="success-cancellation-modal-container">
            <div className="success-cancellation-modal-header-cont">
              <div
                className="success-cancellation-modal-header-close"
                onClick={handleClose}
              >
                Close
                <img src={close_icon} alt="" />
              </div>
            </div>
            <div className="success-cancellation-modal-img">
              <img src={tick} alt="" />
            </div>
            <div className="success-cancellation-modal-cont">
              <div className="success-cancellation-modal-title">
                Appointment cancelled successfully
              </div>
              <div className="success-cancellation-modal-subtitle">
                The patient appointment is cancelled successfully. In case of
                any query, <br />
                please contact our team at{" "}
                <span style={{ color: "#f969a4" }}> 1800 267 9899.</span>
              </div>
              <div className="cancellation-reason">Reason : {reason}</div>
            </div>

            <div className="success-cancellation-modal-footer">
              <div
                className="success-cancellation-modal-footer-btn"
                onClick={handleClose}
              >
                Okay
              </div>
            </div>
          </div>
        </Dialog>
      )}
    </>
  );
};

export default withStyles(styles)(SuccessCancellationModal);
